import { TemplateKey } from "PFApp/constants/templates";
import { Activity, AuditRole, ClosureReasonKey, Option, Snakify, Template } from "PFCore/types";
import { TFunction } from "react-i18next";
import { humanize } from "underscore.string";

export const getActivityType = (template: Template | undefined, t: TFunction<"activities">) => {
  const key = template?.key || "";

  return t(`templates.${key}` as unknown as TemplateStringsArray, {
    defaultValue: humanize(key)
  }) as string;
};

export const findActivityTemplate = (
  templates: Template[],
  activity: Activity | Snakify<AuditRole>,
  type: TemplateKey
) => templates.find((template) => template.id === activity.template_id || template.key === type);

export const buildCloseOptions = (
  availableClosureReasons: { key: ClosureReasonKey; label: string; hidden?: boolean; massClose?: boolean }[]
): Option<ClosureReasonKey>[] =>
  availableClosureReasons
    .filter(({ hidden, massClose }) => !hidden && massClose !== false)
    .map((option) => ({
      id: option.key,
      value: option.label,
      displayElement: option.label,
      original: option.key
    }));

export const buildCloseReasons = (
  availableClosureReasons: { key: ClosureReasonKey; label: string }[]
): Record<string, string> =>
  availableClosureReasons.reduce((acc, val) => ({ ...acc, [val.key]: val.label }), {});

export const getIsSubmitDisabled = ({
  isAuditRole,
  hasOpenVacancies,
  selectedCloseReason,
  isShortlistsFetching
}: {
  isAuditRole: boolean;
  hasOpenVacancies: boolean;
  selectedCloseReason: string | undefined | null;
  isShortlistsFetching: boolean;
}) => (isAuditRole && hasOpenVacancies && !selectedCloseReason) || isShortlistsFetching;
